<template>
  <Modal
    extra-class="dea-modal__other-school dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      La tua Scuola
    </template>
    <template #content>
      <div class="dea-modal__other-school-input">
        <div class="dea-modal__other-school-input-label dea-heading--medium-m">
          Scrivici per esteso il nome dell'Istituto in cui lavori (esempio: IC Aldo Moro - Saronno)
        </div>
        <InputText v-model="schoolName" placeholder="Scrivi il nome della tua scuola"></InputText>
      </div>
      <div class="dea-modal__other-school-input">
        <div class="dea-modal__other-school-input-label dea-heading--medium-m">
          Scrivici l'indirizzo della tua scuola, specificando anche la provincia (esempio: Viale Santuario, 13 - Saronno
          (VA)
        </div>
        <InputText v-model="schoolAddress" placeholder="Scrivi l'indirizzo della tua scuola"></InputText>
      </div>
      <div class="dea-modal__other-school-button">
        <Buttons class="dea-button--large" :disabled="!schoolAddress || !schoolName" @click="save()">
          Salva modifiche
        </Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import InputText from "@/components/elements/InputText";
import Modal from "@/components/patterns/Modal";

export default {
  name: "SchoolModal",
  components: { Buttons, InputText, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      schoolAddress: "",
      schoolName: "",
    };
  },
  mounted() {
    this.schoolAddress = this.user.other_school_address ? this.user.other_school_address : "";
    this.schoolName = this.user.other_school_name ? this.user.other_school_name : "";
  },
  methods: {
    save() {
      this.$emit("user-update", { other_school_address: this.schoolAddress, other_school_name: this.schoolName });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal__other-school {
  @include media("<s") {
    width: 100%;
  }

  max-width: 100%;

  &-input {
    margin-bottom: $space-intermediate;

    &-label {
      margin-bottom: $space-small;
    }

    .dea-input {
      width: 100% !important; //sass-lint:disable-line no-important
    }
  }

  &-button {
    margin: $space-intermediate 0;
  }
}
</style>
